import {
    cilAirplaneMode,
    cilArrowRight,
    cilBan,
    cilBarChart,
    cilBell,
    cilBriefcase,
    cilBug,
    cilBuilding,
    cilCalendar,
    cilCaretBottom,
    cilCaretTop,
    cilChartLine,
    cilCheck,
    cilCheckAlt,
    cilCheckCircle,
    cilChevronBottom,
    cilChevronTop,
    cilClipboard,
    cilClock,
    cilCloudDownload,
    cilCloudUpload,
    cilCog,
    cilDataTransferDown,
    cilDescription,
    cilEnvelopeClosed,
    cilExternalLink,
    cilFile,
    cilFork,
    cilGroup,
    cilImagePlus,
    cilInfo,
    cilLanguage,
    cilLayers,
    cilList,
    cilListFilter,
    cilLocationPin,
    cilLockLocked,
    cilLockUnlocked,
    cilLoop,
    cilMedicalCross,
    cilMenu,
    cilMinus,
    cilMobile,
    cilNotes,
    cilPaperclip,
    cilPaperPlane,
    cilPencil,
    cilPhone,
    cilPlus,
    cilQrCode,
    cilReload,
    cilScreenDesktop,
    cilSitemap,
    cilTag,
    cilTags,
    cilTask,
    cilTrash,
    cilUser,
    cilUserFollow,
    cilViewColumn,
    cilWarning,
    cilWifiSignal2,
    cilWifiSignal4,
    cilWifiSignalOff,
    cilX,
    cilXCircle,
    flagSet,
} from '@coreui/icons';

import { logoCurie, logoLarge, logoSmall } from './logo';

export const iconsSet = Object.assign({}, { logoSmall, logoLarge, logoCurie }, flagSet, {
    cilAirplaneMode,
    cilArrowRight,
    cilBan,
    cilBarChart,
    cilBell,
    cilBriefcase,
    cilBug,
    cilCalendar,
    cilCaretBottom,
    cilCaretTop,
    cilChartLine,
    cilCheck,
    cilCheckAlt,
    cilCheckCircle,
    cilChevronBottom,
    cilChevronTop,
    cilClipboard,
    cilClock,
    cilCloudDownload,
    cilCloudUpload,
    cilCog,
    cilDataTransferDown,
    cilDescription,
    cilEnvelopeClosed,
    cilExternalLink,
    cilFile,
    cilFork,
    cilGroup,
    cilImagePlus,
    cilInfo,
    cilLanguage,
    cilLayers,
    cilList,
    cilListFilter,
    cilLocationPin,
    cilLockLocked,
    cilLockUnlocked,
    cilLoop,
    cilMedicalCross,
    cilMenu,
    cilMobile,
    cilNotes,
    cilPaperclip,
    cilPaperPlane,
    cilPencil,
    cilPhone,
    cilPlus,
    cilQrCode,
    cilReload,
    cilScreenDesktop,
    cilSitemap,
    cilTag,
    cilTags,
    cilTask,
    cilTrash,
    cilUser,
    cilViewColumn,
    cilWarning,
    cilWifiSignal2,
    cilWifiSignal4,
    cilWifiSignalOff,
    cilX,
    cilXCircle,
    cilMinus,
    cilBuilding,
    cilUserFollow,
});
